import {
  Button,
  Modal,
  Typography,
  Input,
  Form,
  FormItem,
  LazyImage,
} from '@frontend/design_system'
import { PROFILE_CREATE_ACCOUNT } from 'texts/profileDetails'
import styles from './styles.module.scss'
import { useState } from 'react'
import { FormItemChildren } from 'types/form'
import { useApiRequest } from 'hooks/useApiRequest'
import { profileApi } from 'api'
import userIcon from 'assets/icons/blue700/blue700_user_16x16.webp'
import { useCompanyId } from 'hooks/useCompanyId'
import { setNotificationMessage } from 'redux/notifications/slice'
import { useDispatch } from 'react-redux'
import { CreateAccountButtonProps } from './types'
import { CANCEL } from 'texts/uiTexts'
import { CREATE_ACCOUNT_FORM_VALUES } from './constants'
import { emailRules } from 'texts/validateRules'

export const CreateAccountButton = ({
  isAccountExists,
}: CreateAccountButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const companyId = useCompanyId()
  const dispatch = useDispatch()

  const { apiRequest, loading } = useApiRequest(
    (email, companyId) => profileApi.sendMigrationCode(email, companyId),
    undefined,
    true,
    undefined,
    false
  )

  const handleModalOpen = () => {
    setIsModalOpen(true)
  }

  const handleModalClose = () => {
    setIsModalOpen(false)
  }

  const handleSubmit = async (values: { email: string }, validate: boolean) => {
    if (validate) {
      const response = await apiRequest(values.email, companyId)
      if (response) {
        handleModalClose()
        dispatch(
          setNotificationMessage({
            notificationMessage: PROFILE_CREATE_ACCOUNT.INVITATION_SENT,
          })
        )
      }
    }
  }

  if (isAccountExists) {
    return null
  }

  return (
    <>
      <Button
        label={PROFILE_CREATE_ACCOUNT.BUTTON}
        size="large"
        typographyName="Button2"
        variant="link"
        iconRight={<LazyImage width={16} height={16} src={userIcon} />}
        widthClassName={styles['button-wrapper']}
        onClick={handleModalOpen}
      />
      {isModalOpen && (
        <Modal
          position="center-horizontal"
          onClose={handleModalClose}
          isDelimiter
          title={PROFILE_CREATE_ACCOUNT.MODAL_TITLE}
          headerSize="large"
        >
          <div className={styles.content}>
            <Typography name="body1WMedium" color="grey500">
              {PROFILE_CREATE_ACCOUNT.MODAL_CONTENT}
            </Typography>
            <Form onSubmit={handleSubmit} initValues={{ email: '' }}>
              <FormItem
                id={CREATE_ACCOUNT_FORM_VALUES.EMAIL.ID}
                className={styles['form-item']}
                rules={emailRules}
              >
                {({ value, error, onChange }: FormItemChildren) => (
                  <Input
                    value={value}
                    placeholder={CREATE_ACCOUNT_FORM_VALUES.EMAIL.PLACEHOLDER}
                    size="large"
                    error={error}
                    onChange={onChange}
                    label={CREATE_ACCOUNT_FORM_VALUES.EMAIL.LABEL}
                    isRequired
                  />
                )}
              </FormItem>
              <div className={styles.buttons}>
                <Button
                  label={CANCEL}
                  onClick={handleModalClose}
                  variant="secondary-border"
                  size="large"
                />
                <Button
                  loading={loading}
                  label={PROFILE_CREATE_ACCOUNT.CREATE}
                  htmlType="submit"
                  size="large"
                />
              </div>
            </Form>
          </div>
        </Modal>
      )}
    </>
  )
}
